import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';


export function isGroupSetsEnabledForSite() {
    return SessionSiteSelectors.isGroupSetsEnabledForSite(getAppStore().getState());
}